<template>
  <div id="app" :class="theme">
    <header>
      <nav class="navigation">
        <h2 class="app-title color-change">Where in the world?</h2>
        <div class="toggler">
          <label for="theme" class="color-change"><i class="fas fa-moon"></i>Dark Mode</label>
          <input type="checkbox" id="theme" ref="theme" @change="changeTheme()">
        </div>
      </nav>
    </header>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      theme: {}
    }
  },
  methods: {
    changeTheme () {
      let input = this.$refs.theme
      if (input.checked) {
        this.theme = { light: true }
      } else {
        this.theme = { light: false }
      }
    }
  }
}
</script>

<style>
a {
  text-decoration: none;
}

#app {
  background: hsl(207, 26%, 17%);
  width: 100vw;
  transition: background .4s ease;
}

#app.light {
  background: hsl(0, 0%, 98%);
}

#app .color-change {
  color: hsl(0, 0%, 100%);
}

#app.light .color-change {
  color: hsl(200, 15%, 8%);
}

.btn,
#continent {
  background: hsl(209, 23%, 22%);
  border: none;
  outline: none;
  transition: .4s ease;
}

#app.light .btn,
#app.light #continent {
  background: hsl(0, 0%, 100%);
}

#continent {
  color: hsl(0, 0%, 98%);
}

#app.light #continent {
  color: hsl(207, 26%, 17%);
}

#theme {
  -webkit-appearance: none;
  appearance: none;
}

label {
  cursor: pointer;
}

ul {
  list-style: none;
}

li {
  color: hsl(0, 0%, 100%);
  transition: color .4s ease;
}

#app.light li {
  color: hsl(200, 15%, 8%);
}

header {
  width: 100vw;
  height: 10vh;
  padding: 1.5rem;
  box-shadow: 0 .5rem .5rem rgba(0,0,0,.06);
  background: hsl(209, 23%, 22%);
  transition: background .4s ease;
}

#app.light header {
  background: hsl(0, 0%, 100%);
}

.navigation {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app-title {
  font-weight: 800;
  font-size: 1.8rem;
}

.toggler label {
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: .2rem;
}

.color-change {
  transition: .4s ease;
}

header .fas {
  margin-right: 1rem;
}

/* MEDIA QUERIES */
@media (max-width: 375px) {
  .app-title {
    font-size: 1.4rem;
  }

  .toggler label {
    font-size: 1rem;
  }
}

@media (min-width: 768px) {
  /* #app {
    height: 100vh;
  } */

  header {
    padding: 1.5rem 0;
  }

  .navigation {
    width: 90%;
    margin: 0 auto;
  }

  .app-title {
    font-size: 2rem;
  }

  .toggler label {
    font-size: 1.25rem;
  }

}
</style>



// WEBPACK FOOTER //
// src/App.vue